import styled from 'styled-components';

const FormLabel = styled.label`
  font-family: ${(p) => p.theme.fontFamily};
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0px;
  color: ${(p) => p.theme.colors.neutral3};
  display: block;
  margin-bottom: 3px;
`;

FormLabel.defaultProps = {
  style: {},
};

export default FormLabel;
